// The prologue screen: six scenes of a childhood, one choice each, played once before the town
// opens. Resolves with the choices by scene id; the server works out what they mean.
import { el } from './dom.js';
import { t } from '../../shared/i18n.js';
import { frame } from './onboarding.js';
import { button } from './components.js';
import { SCENES, originEffects } from '../../shared/content/prologue.js';
import { HOMES, TRAITS, SKILL_NAMES, DREAMS } from '../../shared/content/life.js';

const KEY = 'abakwa-origin';

export function savedOrigin() {
  try {
    const o = JSON.parse(localStorage.getItem(KEY) || 'null');
    return o && typeof o === 'object' ? o : null;
  } catch {
    return null;
  }
}

// A choice's text split into a bold lead (the first sentence) and the rest.
function split(text) {
  const m = text.match(/^(.+?[.!?])\s+(.+)$/);
  return m ? [m[1], m[2]] : [text, ''];
}

export function askPrologue(root, name) {
  return new Promise((resolve) => {
    const origin = {};
    let k = 0;
    let node = null;
    const swap = (next) => {
      if (node) node.remove();
      node = next;
      root.append(node);
    };
    const show = () => {
      if (k < SCENES.length) {
        const s = SCENES[k];
        const list = el('div.scene');
        for (const c of s.choices) {
          const [lead, rest] = split(t(c.text));
          list.append(el('button.act.choice-card', { type: 'button', onclick: () => { origin[s.id] = c.id; k++; show(); } }, el('b', null, lead), rest ? el('span', null, ' ' + rest) : null));
        }
        swap(frame({
          step: 3,
          kicker: `${name} · ${t('scene {n} of {total}', { n: k + 1, total: SCENES.length })}`,
          title: t(s.title),
          lead: t(s.text),
          children: list,
          footer: k > 0 ? button(t('Back'), { kind: 'ghost', icon: 'back', onclick: () => { k--; show(); } }) : null,
        }));
        return;
      }
      const e = originEffects(origin);
      const rows = el('dl.summary');
      rows.append(el('dt', null, t('Traits')), el('dd', null, e.traits.length ? e.traits.map((k) => t(TRAITS[k].name)).join(', ') : t('None yet; pick two on the phone')));
      rows.append(el('dt', null, t('Skills')), el('dd', null, Object.entries(e.skills).map(([s, v]) => `${t(SKILL_NAMES[s])} ${v}`).join(', ') || t('None yet')));
      rows.append(el('dt', null, t('Dream')), el('dd', null, e.dream ? t(DREAMS[e.dream]) : t('Not yet')));
      rows.append(el('dt', null, t('Home')), el('dd', null, `${t(HOMES[e.home].name)}, ${HOMES[e.home].where}`));
      rows.append(el('dt', null, t('In your pocket')), el('dd', null, `${e.money.toLocaleString('en-US')} FCFA`));
      const go = el('button.go', { type: 'button', onclick: () => {
        try {
          localStorage.setItem(KEY, JSON.stringify(origin));
        } catch {
          // not remembered: the server keeps it anyway
        }
        node.remove();
        resolve(origin);
      } }, t('Enter the town'));
      swap(frame({
        step: 4,
        kicker: name,
        title: t('So you arrive in town'),
        lead: e.start === 'bushfaller' ? t('A bushfaller family sends money home every Saturday.') : t('A quarter pikin with two legs and a seat in the njangi.'),
        children: el('div.scene', null, rows),
        footer: [go, button(t('Live it again'), { kind: 'ghost', onclick: () => { k = 0; show(); } })],
      }));
    };
    show();
  });
}
